export default {
  autoUpdate: 'Aktualizuj automatycznie',
  updateInterval: 'Interwał aktualizacji',
  lastUpdate: 'Ostatnia aktualizacja',
  nextUpdate: 'Następna aktualizacja za {0}',
};
